import { last } from 'lodash-es';

import { InstanceData } from './types';

const __ROOT__ = '';
const REGION_PATH_PATTERN = '{region}';
const DEFAULT_CONFIG_PATH = `${__ROOT__}src/config/`;

type ResolvePathCtx = {
    instanceData: InstanceData;
};

export type ResolvePathParams = {
    region: string;
    lob: string;
    configFileOverride?: string;
};
type ResolvePathReturnedValue = string;

export const resolvePath =
    ({ instanceData }: ResolvePathCtx) =>
    ({ region, lob, configFileOverride }: ResolvePathParams): ResolvePathReturnedValue => {
        const baseConfigFilePath =
            configFileOverride ?? instanceData.customPath ?? DEFAULT_CONFIG_PATH;

        const baseConfigFilePathHasExtension = !!baseConfigFilePath.split('.')[1];
        if (!baseConfigFilePathHasExtension) {
            instanceData.customPath = baseConfigFilePath;
            const needsMiddleSlash = last(baseConfigFilePath) !== '/';

            return `${baseConfigFilePath}${needsMiddleSlash ? '/' : ''}${lob}-${region}.json`;
        } else {
            instanceData.customPath = baseConfigFilePath.split('/').slice(0, -1).join('/');

            if (baseConfigFilePath.includes(REGION_PATH_PATTERN)) {
                instanceData.customPath = baseConfigFilePath;
                const replacedBaseConfigFilePath = baseConfigFilePath.replace(
                    REGION_PATH_PATTERN,
                    region,
                );
                return replacedBaseConfigFilePath;
            }
        }
        return baseConfigFilePath;
    };
